import React, { useEffect,useState} from 'react';
import {  Nav, Pagination } from "react-bootstrap";
import {Link} from 'react-router-dom';


const PagePagination = ({dataCount, perPage, pegiFunction}) => {

    const [activePegi, setActivePagi] = useState(1);
    const [paginateLimit, setPaginateLimit] = useState(5);
    const [startPeginate, setStartPeginate] = useState(1);

    const [items, setItems] = useState([]);
    const [hideRight, sethideRight] = useState(false);
    const [hideLeft, setHideLeft] = useState(false);
    let totalCount = dataCount || 0
    let pages = Math.ceil(totalCount / perPage);
    const [totalPages, setTotalPages] = useState(pages);
    const [endPeginate, setEndPeginate] = useState(pages > paginateLimit ? paginateLimit : pages);


    useEffect(() => {
        setTimeout(()=>{
            if(totalCount > 0){
                paginator(totalPages,1)
            }
        },500)
    }, [dataCount]);

    const paginator = (pages, page) => {

        let pegiItems = [];
        for (let number = startPeginate; number <= endPeginate; number++) {
            if(pages === 1){
                sethideRight(true)
                setHideLeft(true)
            }else{

                if(page > 1){
                    setHideLeft(false)
                }

                if(page === 1){
                    setHideLeft(true)
                }

                if(pages > page){
                    sethideRight(false)
                }

                if(pages === page){
                    sethideRight(true)
                }
            }

            pegiItems.push(
                <Pagination.Item key={number} active={number === activePegi} onClick={()=>changePagination(number)}>
                    {number}
                </Pagination.Item>
            );
        }
        setItems(pegiItems)
    }

    const changePaginationNext = () => {
        setActivePagi(activePegi+1)
        let page = activePegi+1
        if((page - endPeginate) === 0 && totalPages > endPeginate){
            setStartPeginate(startPeginate + 1)
            setEndPeginate(endPeginate + 1)
        }
        pegiFunction(activePegi+1,perPage)

    }

    const changePaginationPrevious = () => {
        setActivePagi(activePegi-1)
        let page = activePegi-1
        if((page - startPeginate) === 0 && startPeginate > 1){
            setStartPeginate(startPeginate - 1)
            setEndPeginate(endPeginate - 1)
        }
        pegiFunction(activePegi-1,perPage)
    }

    const changePagination = (page) => {
        if(activePegi !== page){
            if(totalPages <= paginateLimit){
                setStartPeginate(1)
                setEndPeginate(totalPages)
            }else{
                if((page - endPeginate) === 0 && totalPages > endPeginate){
                    setStartPeginate(startPeginate + 1)
                    setEndPeginate(endPeginate + 1)
                }


                if((page - startPeginate) === 0 && startPeginate > 1){
                    setStartPeginate(startPeginate - 1)
                    setEndPeginate(endPeginate - 1)
                }

            }
        }

        setActivePagi(page)
        pegiFunction(page,perPage)

    }

    useEffect(() => {
        paginator(totalPages,activePegi)
    }, [activePegi]);

    const pag = (size, gutter, variant, bg, circle) => (
        <Pagination
            size={size}
            className={`  ${gutter ? "pagination-gutter" : ""} ${
            variant && `pagination-${variant}`
                } ${!bg && "no-bg"} ${circle && "pagination-circle"}`}
        >

            {
                !hideLeft ?
                    <li className="page-item page-indicator" onClick={()=>changePaginationPrevious()}>
                        <Link className="page-link" to="#">
                            &lt;&lt;
                        </Link>
                    </li>
                    :
                    <li className="page-item page-indicator">
                        <Link className="page-link" style={{backgroundColor:'#B0B0B0'}} to="#">
                            &lt;&lt;
                        </Link>
                    </li>
            }
            {items}
            {
                !hideRight ?
                    <li className="page-item page-indicator" onClick={()=>changePaginationNext()} >
                        <Link className="page-link" to="#">
                            &gt;&gt;
                        </Link>
                    </li>
                    :
                    <li className="page-item page-indicator" >
                        <Link className="page-link" style={{backgroundColor:'#B0B0B0'}} to="#">
                            &gt;&gt;
                        </Link>
                    </li>
            }

        </Pagination>
    );

    return (
        <Nav>{pag("xs", true, "warning", true, false)}</Nav>
    )

}

export default PagePagination